import { circular } from "../client";

export const addCircular = (params) => {
  const user = {
    flag: "addCircular",
    parameters: {
      circulars: params,
    },
  };
  return circular.post("/circular/add", user);
};

export const updateCircular = (params) => {
  const user = {
    flag: "updateCircular",
    parameters: {
      circulars: params,
    },
  };
  return circular.post("/circular/update", user);
};

export const getAllCircular = (params) => {
  const user = {
    flag: "getAllCircular",
    parameters: {
      circulars: {
        limit: params.limit,
        offset: params.offset,
        institutionId: params.institutionId,
      },
    },
  };
  return circular.post("/get/circulars", user);
};

export const deleteCircular = (params) => {
  const user = {
    flag: "deleteCircular",
    parameters: {
      circulars: params,
    },
  };
  return circular.delete("/delete/circular", { data: user });
};

export const getTargetAudience = (params) => {
  const user = {
    flag: "getTargetAudience",
    parameters: {
      targetAudience: {
        institutionId: params.institutionId,
      },
    },

  };
  return circular.post("/get/all/targetAudience", user);
};

export const getStudentsById = (params) => {
  const user = {
    flag: "getStudentsByCurrentYear",
    parameters: {
      circulars: {
        currentYear: params.currentYear,
        institutionId:params.institutionId,
        idDepartment:params.DepartmentID
      },
    },
  };
  return circular.post("/get/students/currentyear", user);
};

export const getBatchByDepartmentID = (params) => {
  const user = {
    flag: "getBatchByIdDepartment",
    parameters: {
      migratingStudents: {
        idDepartment: params.idDepartment,
        institutionId: params.institutionId,
      },
    },
  };
  return circular.post("/get/batch/idDepartment", user);
};

export const getStudentsByBatchYear = (params) => {
  const user = {
    flag: "getStudentsByBatch",
    parameters: {
      migratingStudents: {
        idDepartment: params.idDepartment,
        batchYear: params.batchYear,
        institutionId: params.institutionId,
      },
    },
  };
  return circular.post("/get/students/batchAndIdDepartment", user);
};

export const updateCurrentYear = (params) => {
  const user = {
    flag: "updateCurrentYear",
    parameters: {
      migratingStudents: {
        studentsList: params.studentsList,
        currentYear: params.currentYear,
      },
    },
  };
  return circular.post("/update/student/currentYear", user);
};

export const searchStudentForMigration = (params) => {
  const user = {
    flag: "searchStudentForMigration",
    parameters: {
      students: {
        institutionId: params.institutionId,
        idDepartment: params.idDepartment,
        regNumber: params.regNumber,
        batchYear: params.batchYear,
        limit: params.limit,
        offset: params.offset,
      },
    },
  };
  return circular.post("search/student/migration", user);
};